import Vue from 'vue'

import 'normalize.css/normalize.css'// A modern alternative to CSS resets

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import locale from 'element-ui/lib/locale/lang/zh-CN' // lang i18n
import VCharts from 'v-charts'

//引入i18n国际化
import i18n from './language/i18n';

import '@/styles/index.scss' // global css

import App from './App'
import router from './router'
import store from './store'

import '@/icons' // icon
import '@/permission' // permission control

//设置本地语言并初始化i18n支持
Vue.use(ElementUI, { locale, i18n: (key, value) => i18n.t(key, value) })
Vue.use(VCharts)

Vue.config.productionTip = false

//Vue.use(VueI18n);

new Vue({
  el: '#app',
  router,
  store,
  i18n,
  template: '<App/>',
  components: { App }
})




// WEBPACK FOOTER //
// ./src/main.js